import {playIfInView, isInViewport} from './includes/helpers';

// Shim Function to make IE9+ support forEach:
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

console.log('test');

// Handler when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function() {
    const MOBILE_BP = 768;
    const $siteHeader = document.getElementById('site-header');
    const $hamburger = document.getElementById('hamburger');
    const $mainNav = document.getElementById('main-nav');
    const $bgVids = document.querySelectorAll('.background-video video');

    function atTop() {
        // If we're not at the top of the page add a backdrop
        ( window.scrollY <= 40 ) ?
            $siteHeader.classList.add('at-top') :
            $siteHeader.classList.remove('at-top');
    }

    atTop();

    //
    // SCROLL DETECTION
    //
    let last_known_scroll_position = 0;
    let ticking = false;

    window.addEventListener('scroll', function(e) {
        let direction = (window.scrollY > last_known_scroll_position) ?
            'down' : 'up';
        last_known_scroll_position = window.scrollY;

        if (!ticking) {
            window.requestAnimationFrame(function() {
                atTop();
                ticking = false;
            });
            ticking = true;
        }
    });


    $hamburger.addEventListener('click', function() {
        this.classList.toggle('is-active');
        $mainNav.classList.toggle('is-active');
        document.body.classList.toggle('hamburger-active');
    });

    // NOT MOBILE
    if ( window.matchMedia("(min-width: " + MOBILE_BP + "px" + ")").matches ) {

        $bgVids.forEach( function(el, i) {
            const $vidSource = el.querySelector('source');
            const vidSrc = $vidSource.getAttribute('data-src');
            const posterImg = el.getAttribute('data-poster');
            el.setAttribute('poster', posterImg);
            $vidSource.setAttribute('src', vidSrc);
            el.src = vidSrc;
        });


        console.log('NOT MOBILE');
    } else {
        // MOBILE
        console.log('mobile');

    }
    console.log('test');

});
